import React, { useCallback, useState } from 'react';
import { Page, Layout, TextField, Button, Card, Banner, Spinner, Icon } from '@shopify/polaris';
import { createNewApp } from '../../dev_services/developer/api';
import { ToastContainer, toast } from 'react-toastify';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { saveResponseData } from '../../dev_store/slice/app_created_response_slice/app_create_response';
import {
    NoteAddIcon
} from '@shopify/polaris-icons';
import '../../dev_pages/dev_create_apps/create_app.scss'
export default function CreateAppView() {
    const [appName, setAppName] = useState('');
    const [isLoading, setLoading] = useState(false);
    const [shortDescription, setShortDescription] = useState('');
    const [appNameError, setAppNameError] = useState<string | null>(null);
    const [shortDescriptionError, setShortDescriptionError] = useState<string | null>(null);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const validateAppName = useCallback(() => {
        if (appName.trim().length === 0 || appName.trim().length > 30) {
            setAppNameError('App Name must be between 1 and 30 characters');
            return false;
        }

        setAppNameError(null);
        return true;
    }, [appName]);

    const validateShortDescription = useCallback(() => {
        if (shortDescription.trim().length === 0) {
            setShortDescriptionError('Short Description is required');
            return false;
        }

        setShortDescriptionError(null);
        return true;
    }, [shortDescription]);

    const handleSubmit = useCallback(async () => {

        const isAppNameValid = validateAppName();
        const isShortDescriptionValid = validateShortDescription();

        if (isAppNameValid && isShortDescriptionValid) {
            // Your submit logic here

            // Clear fields on successful submission

            const data = {
                "name": appName,
                "description": shortDescription
            }
            try {
                setLoading(true);
                const responseData = await createNewApp(data);

                // Assuming responseData is already an object, no need to parse it
                if (responseData.token !== null) {
                    toast.success("Login Successfully");
                     console.log("Response Data:", responseData);
                    console.log(responseData.api_secret)

                    dispatch(saveResponseData({
                        api_key: responseData.api_key,
                        api_secret: responseData.api_secret,
                        app_id: responseData.app_id,
                        slug: responseData.slug
                    }));


                    // Redirect to the developer dashboard after successful login
                    navigate(`/developer/${responseData.app_id}/appoverview`);

                }
            } catch (error) {
                console.error("Error occurred while creating app:", error);
                toast.error("Something went wrong. Please try again later.");
            }
            finally {
                setAppName('');
                setShortDescription('');
                setLoading(false);
            }
        }
    }, [validateAppName, validateShortDescription]);

    return (
        <>
            <div className='developer-page-frame nav-icons' style={{ backgroundColor: "#f6f6f7" }}>
                <ToastContainer style={{ paddingTop: "50px" }} />
                <div style={{ paddingLeft: "2.0rem", paddingRight: "2.0rem", backgroundColor: "#f6f6f7" }}>
                    <div className='flex'>
                        <div style={{ paddingTop: "20px", gap: "10px", display: 'flex' }}>
                            <Icon
                                source={NoteAddIcon}
                                tone="base"
                            />
                            <label style={{ fontFamily: "sfprobold", fontSize: "20px", lineHeight: "revert" }} className="font-medium text-base">
                                Create New App
                            </label>
                        </div>
                    </div>

                    {/* <label style={{ fontFamily: "sfpromedium", fontWeight: "500" }} className="font-medium text-lg">Overview</label> */}
                    <div className="pt-9 ">
                        {/* <label style={{ fontFamily: "sfpromedium", fontWeight: "400" }} className="font-medium text-base w-full sm:w-48">Create A New APP</label> */}
                        <div>
                            <ToastContainer style={{ top: "60px" }} /> {/* Add ToastContainer here */}
                            <Card>
                                <div>
                                    <label style={{ fontFamily: "sfprobold", fontSize: "16px", paddingTop: "10px", }} className="font-medium text-base w-full sm:w-48">Generate API Credentials</label>

                                </div>
                                <div style={{ paddingTop: "10px", paddingBottom: "10px", }}>
                                    <label >Create an app from scratch.</label>

                                </div>
                                <TextField
                                    maxLength={32}
                                    value={appName}
                                    onChange={setAppName}
                                    label="App Name"
                                    autoComplete="App Name"
                                    error={appNameError !== null}
                                />

                                {appNameError && <div style={{ paddingTop: "10px" }}>
                                    <Banner >{appNameError}</Banner></div>}

                                <div className="mt-4">

                                    <TextField
                                        maxLength={100}
                                        showCharacterCount
                                        value={shortDescription}
                                        onChange={setShortDescription}
                                        label="Short Description"
                                        autoComplete="Short Description"
                                        multiline={3}
                                        error={shortDescriptionError !== null}
                                    />
                                    {shortDescriptionError && (
                                        <div style={{ paddingTop: "10px" }}>
                                            <Banner>{shortDescriptionError}</Banner>
                                        </div>
                                    )}
                                </div>

                                <div className="mt-4 btn-app">
                                    {isLoading === false ?
                                      <Button onClick={handleSubmit} submit>
                                            Create App
                                        </Button>


                                        : <>
                                            <Spinner size='small' ></Spinner>
                                        </>}
                                </div>
                            </Card>
                        </div>
                    </div>

                </div>

            </div>
        </>

    );
}
